import React, { Component } from "react";
import { observer } from "mobx-react";
import { reaction } from "mobx";
import reportsStore from "../reportsStore";
import SequenceGraphComponent from "../sequence/SequenceGraphComponent";
import ReportsActivity from "../activity/ReportsActivity";

import { HEADERS } from "../constants";

@observer
class ReportsWhatsApp extends Component {
  disposeReaction = null;

  componentDidMount() {
    this.fetchData();

    this.disposeReaction = reaction(
      () => [reportsStore.dateFilter, reportsStore.memberIds],
      () => {
        this.fetchData();
      }
    );
  }

  componentWillUnmount() {
    if (this.disposeReaction) {
      this.disposeReaction();
    }
  }

  fetchData = () => {
    reportsStore.fetchWhatsAppAnalytics();
  };

  constructGraphWhatsAppData = () => {
    const {
      waMessagesSent = 0,
      waRepliesReceived = 0
    } = reportsStore.whatsAppAnalyticsData || {};

    const graphData = [
      {
        header: "Messages",
        totalCount: waMessagesSent + waRepliesReceived,
        dataArr: [
          {
            label: "Sent",
            value: waMessagesSent ?? 0,
            color: "#25D366"
          },
          {
            label: "Replies received",
            value: waRepliesReceived ?? 0,
            color: "#128C7E"
          }
        ]
      }
    ];
    return graphData;
  };

  render() {
    const graphData = this.constructGraphWhatsAppData();

    const allowedHeaders = ["waMessagesSent", "waRepliesReceived"];

    const extraHeaders = HEADERS.filter(h =>
      allowedHeaders.includes(h.name)
    ).map(header => ({
      ...header,
      displayName: header.displayName.replace("WhatsApp ", "")
    }));

    return (
      <div className="reportsWhatsApp">
        <SequenceGraphComponent
          graphDataArr={graphData}
          hideTotalCount={true}
          customClassName="whatsAppGraphsCont"
        />
        <ReportsActivity
          allowedHeaders={allowedHeaders}
          extraHeaders={extraHeaders}
        />
      </div>
    );
  }
}

export default ReportsWhatsApp;
